<div class="container-fluid">
  <div class="row">
    <div class="col">
      <ul class="breadcrumb">
        <li><strong>ONDE ESTOU:</strong></li>
        <li class="active">
          <span>{{"Postos - Upload planilha de preços de combustíveis".toUpperCase()}}</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-md-7 col-lg-8 col-xl-8">
    </div>
    <div class="col-md-5 col-lg-4 col-xl-4 d-flex justify-content-end">

      <button class="btn btn-terceary" title="Baixar modelo de planilha" (click)="baixarModelo()"><img
        src="assets/icons/download.svg" alt="icon download" loading="eager" width="20px" height="20px"
        class="icone"> BAIXAR PLANILHA
      </button>


      <label for="file-upload" title="SELECIONE UM ARQUIVO CSV" class="btn btn-terceary">
        <input id="file-upload"
               (change)="onFileSelected($event)"
               type="file" accept=".csv"/>
        <img src="assets/icons/upload.svg" alt="icon download" loading="eager" width="20px" height="20px"
             class="icone">ENVIAR PLANILHA DE PREÇOS
      </label>
      <button title="Retornar para pagina principal"
              class="btn btn-terceary"
              routerLink="/preco-combustivel">VOLTAR
      </button>

    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-lg-4 col-xl-5">
      <mat-form-field class="w-100">
        <mat-label>FILTRAR</mat-label>
        <input matInput (keyup)="applyFilter($event)"
               placeholder="FILTRAR DADOS POR 'COD. POSTO CTF', 'CNPJ', 'CHAVE' 'RAZAO SOCIAL' OU 'TIPO DE COMBUSTIVEL'">
      </mat-form-field>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-7"></div>
  </div>

  <!--  <pre>-->
  <!--      {{this.dataSource.data[0] | json}}-->
  <!--  </pre>-->

  <div class="row">
    <div class="col-12" *ngIf="this.mensagenserroscsv.length > 0">
      <div class="alert alert-danger">
        <p>
          <strong>FORAM ENCONTRADOS {{ this.mensagenserroscsv.length }} ERROS NA PLANILHA!</strong>
        </p>
        <p *ngIf="mostrarTabelaComErros"> CORRIJA OS ERROS LISTADOS EM <strong style="color: black; background-color: darkgray">CINZA</strong> NA PLANILHA E ENVIE NOVAMENTE.
        </p>
      </div>
      <ul>
        <li *ngFor="let item of mensagenserroscsv">
          {{ item.mensagem.toUpperCase() }}
        </li>
      </ul>
    </div>

    <div class="col-12" *ngIf="this.existeLinhaModificada">
      <p style="background-color: #FFF3CD; margin: 0 0 12px; padding: 3px 16px">LINHAS MODIFICADAS DESTACADAS EM AMARELO</p>
    </div>

  </div>

  <div class="row" *ngIf="this.mostrarTabelaComErros">
    <div class="col-12">
      <div class="table-responsive">

        <table mat-table [dataSource]="dataSource" matSort class="w-100">
          <ng-container matColumnDef="codigoPosto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cod. Posto CTF</th>
            <td mat-cell *matCellDef="let element">
              {{ element.codigoPosto }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cnpj">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CNPJ</th>
            <td mat-cell *matCellDef="let element">
              {{ element.cnpj | cnpj }}
            </td>
          </ng-container>

          <ng-container matColumnDef="chave">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Chave</th>
            <td mat-cell *matCellDef="let element">
              {{ element.chave }}
            </td>
          </ng-container>

          <ng-container matColumnDef="razaoSocial">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Razao Social</th>
            <td mat-cell *matCellDef="let element">
              {{ element.razaoSocial }}
            </td>
          </ng-container>

          <ng-container matColumnDef="combustivel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cod. Combustivel</th>
            <td mat-cell *matCellDef="let element">
              {{ element.combustivel }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nomeCombustivel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Combustivel</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nomeCombustivel }}
            </td>
          </ng-container>

          <ng-container matColumnDef="precoTela">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preco Bomba<strong>&nbsp;R$</strong></th>
            <td mat-cell *matCellDef="let element">
              <input type="text" matInput currencyMask class="mat_input"
                     [options]="{ prefix: ' ', thousands: '.', decimal: ',' }"
                     [(ngModel)]="element.precoTela"/>
            </td>
          </ng-container>

          <ng-container matColumnDef="sps">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SPS<strong>&nbsp;R$</strong></th>
            <td mat-cell *matCellDef="let element">
              <input type="text" matInput currencyMask class="mat_input"
                     [options]="{ prefix: ' ', thousands: '.', decimal: ',' }"
                     [(ngModel)]="element.sps"
              />
            </td>
          </ng-container>

          <ng-container matColumnDef="precoRedeEspecial">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preco RE <strong>&nbsp;R$</strong></th>
            <td mat-cell *matCellDef="let element">
              <input type="text" matInput currencyMask class="mat_input"
                     [options]="{ prefix: ' ', thousands: '.', decimal: ',' }"
                     [(ngModel)]="element.precoRedeEspecial"/>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preco atualizado em</th>
            <td mat-cell *matCellDef="let element"> {{
                (element.status) ? (element.status | date:
                  'dd/MM/yyyy HH:mm') : 'Preco inativo '
              }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row
              [ngClass]="verificarMudancas(element)"
              (keyup)="verificarErros(element)"

              *matRowDef="let element; columns: displayedColumns;">
          </tr>

        </table>
      </div>
      <mat-paginator
        [length]="dataSource.data.length"
        [pageSizeOptions]="[26, 52, 104, dataSource.data.length]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>


  <div class="row submitData">
    <div class="col-12">
      <button [disabled]="this.mensagenserroscsv.length > 0 || dataSource.data.length == 0"
              style="min-height: 40px;"
              class="btn btn-terceary btn-lg float-end"
              (click)="mostrarModal = true">
        Submeter preços atualizados
      </button>
    </div>
  </div>


  <div class="modal" tabindex="-1" [hidden]="!mostrarModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Atualização de precos</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  (click)="mostrarModal = false"></button>
        </div>
        <div class="modal-body">
          <h2>Confirmar atualização de preços?</h2>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                  (click)="mostrarModal = false"><img src="assets/icons/cancel.svg" alt="icon download"
                                                      loading="eager" width="20px" height="20px" class="icone">Cancelar
          </button>
          <button type="button" class="btn btn-terceary" (click)="submitData()"><img
            src="assets/icons/confirm.svg" alt="icon download" loading="eager" width="20px"
            height="20px" class="icone">Confirmar preços
          </button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal" id="carregando" tabindex="-1" [hidden]="loading">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-body corpo-spinner">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h2>
            Atualizando preços...
          </h2>
        </div>

      </div>
    </div>
  </div>
</div>
